import React from 'react';
import { useTranslation } from 'react-i18next';

function displayFileLabel(field) {
  if (field?.fileName) return field.fileName;
  if (field?.filePath) {
    const parts = String(field.filePath).split(/[/\\]/);
    return parts[parts.length - 1] || field.filePath;
  }
  return '';
}

/**
 * An imported collection can name a file it expected to upload, but that path
 * is the author's, not the user's, and is never read from disk (COL-01). Show
 * it as a tooltip on the empty chip so the user knows what to pick, while the
 * chip itself stays empty until they actually pick something.
 */
function importedHintTitle(field) {
  const hint = field?.filePathHint;
  if (!hint) return '';
  return `The imported collection referenced "${hint}" — pick a file to upload.`;
}

export default function FormDataFileValueField({ field, onPick }) {
  const { t } = useTranslation();
  const label = displayFileLabel(field);
  const hasFile = Boolean(label);
  const hint = hasFile ? '' : importedHintTitle(field);

  return (
    <div className="request-url-field-group w-full min-w-0 rounded-lg border border-gray-200 overflow-hidden bg-white dark:border-zinc-700 dark:bg-zinc-900">
      <button
        type="button"
        onClick={onPick}
        className={`form-data-file-value-wrap request-builder-kv-input w-full text-left truncate ${
          hasFile ? 'text-gray-900 dark:text-zinc-100' : 'text-gray-400 dark:text-zinc-500'
        }`}
        style={{ minHeight: '36px' }}
        title={hasFile ? label : hint || t('request.formDataSelectFile')}
      >
        {hasFile ? label : t('request.formDataSelectFile')}
      </button>
    </div>
  );
}
